var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTeamWorking(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "contenitore",
    width: 70,
    height: 70,
    transform: "translate(285 633)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "gray",
    stopOpacity: 0.251
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535,
    stopColor: "gray",
    stopOpacity: 0.122
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.102
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "team_working",
    "data-name": "team working",
    transform: "translate(-104 -299)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppo_di_maschere_29",
    "data-name": "Gruppo di maschere 29",
    transform: "translate(-181 -334)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "fondo",
    d: "M3.371,63.393s-5.693-9.719-2.283-18.97S11,37.365,20.12,27.966C31.186,16.55,38.958,15.922,48.828,20.908c5.586,2.821,6.49,14.425,15.379,21.63,8.015,6.5,1.477,17.566-2.73,19.291a20.655,20.655,0,0,1-7.063,1.725S48.09,86.92,29.242,86.119,3.371,63.393,3.371,63.393Z",
    transform: "translate(286.1 616.06)",
    fill: "#dedbdb"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3218",
    "data-name": "Raggruppa 3218",
    transform: "translate(23306 -18130)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3223",
    "data-name": "Raggruppa 3223",
    transform: "translate(-23018.615 18764.473)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3222",
    "data-name": "Raggruppa 3222",
    transform: "translate(0 -0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1240",
    "data-name": "Tracciato 1240",
    d: "M465,80.2q.2,0,.4.007a11.242,11.242,0,1,1-.383,22.482c-.132,0-.264,0-.4-.009A11.242,11.242,0,1,1,465,80.2m0-2.775v0a14.019,14.019,0,1,0-.48,28.033c.164,0,.33.006.494.006a14.019,14.019,0,1,0,.479-28.033c-.164,0-.33-.006-.493-.006Z",
    transform: "translate(-447.316 -74.082)",
    fill: "#03518c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_651",
    "data-name": "Rettangolo 651",
    width: 3.459,
    height: 3.286,
    transform: "translate(16.091 3.457) rotate(-88.012)",
    fill: "#03518c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_652",
    "data-name": "Rettangolo 652",
    width: 3.459,
    height: 3.286,
    transform: "translate(23.421 4.62) rotate(-57.012)",
    fill: "#03518c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_653",
    "data-name": "Rettangolo 653",
    width: 3.459,
    height: 3.286,
    transform: "translate(29.021 9.194) rotate(-27.012)",
    fill: "#03518c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_654",
    "data-name": "Rettangolo 654",
    width: 3.286,
    height: 3.459,
    transform: "translate(28.486 26.041) rotate(-56.012)",
    fill: "#03518c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_655",
    "data-name": "Rettangolo 655",
    width: 3.286,
    height: 3.459,
    transform: "translate(2.284 9.465) rotate(-59.012)",
    fill: "#03518c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_656",
    "data-name": "Rettangolo 656",
    width: 3.459,
    height: 3.286,
    transform: "matrix(0.866, -0.5, 0.5, 0.866, 1.671, 24.154)",
    fill: "#03518c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_657",
    "data-name": "Rettangolo 657",
    width: 3.286,
    height: 3.459,
    transform: "translate(8.297 2.822) rotate(-29.012)",
    fill: "#03518c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_658",
    "data-name": "Rettangolo 658",
    width: 3.459,
    height: 3.286,
    transform: "translate(15.011 34.573) rotate(-88.012)",
    fill: "#03518c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_659",
    "data-name": "Rettangolo 659",
    width: 3.286,
    height: 3.459,
    transform: "translate(22.524 30.465) rotate(-29.012)",
    fill: "#03518c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_660",
    "data-name": "Rettangolo 660",
    width: 3.459,
    height: 3.286,
    transform: "translate(7.31 31.211) rotate(-57.012)",
    fill: "#03518c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_661",
    "data-name": "Rettangolo 661",
    width: 3.978,
    height: 2.941,
    transform: "translate(0.102 15.364) rotate(1.988)",
    fill: "#03518c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_662",
    "data-name": "Rettangolo 662",
    width: 3.978,
    height: 2.941,
    transform: "translate(35.263 19.527) rotate(-178.012)",
    fill: "#03518c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3221",
    "data-name": "Raggruppa 3221",
    transform: "translate(5.348 5.007)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3218-2",
    "data-name": "Raggruppa 3218",
    transform: "translate(0 0)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellisse_103",
    "data-name": "Ellisse 103",
    cx: 12.335,
    cy: 12.335,
    r: 12.335,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellisse_104",
    "data-name": "Ellisse 104",
    cx: 12.075,
    cy: 12.075,
    r: 12.075,
    transform: "translate(0.283 0.181)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1216",
    "data-name": "Tracciato 1216",
    d: "M509.373,132.727c0,4.017-2.886,5.993-6.633,5.993s-6.936-1.977-6.936-5.993a6.8,6.8,0,1,1,13.569,0Z",
    transform: "translate(-490.371 -119.281)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1217",
    "data-name": "Tracciato 1217",
    d: "M502.75,213.581a12.019,12.019,0,0,0,6.638-1.986c-.445-2.432-2.138-2.57-2.138-2.57h-9.337s-1.6.131-2.1,2.368A12.02,12.02,0,0,0,502.75,213.581Z",
    transform: "translate(-490.38 -189.201)",
    fill: "#db5f00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1218",
    "data-name": "Tracciato 1218",
    d: "M291.923,133.874h3.735v3.092a1.763,1.763,0,0,1-1.763,1.763h-.208a1.763,1.763,0,0,1-1.763-1.763v-3.092Z",
    transform: "translate(-281.562 -117.017)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1219",
    "data-name": "Tracciato 1219",
    d: "M292.259,133.027h3.062a.336.336,0,0,1,.336.336v2.755a1.763,1.763,0,0,1-1.763,1.763h-.208a1.763,1.763,0,0,1-1.763-1.763v-2.755a.336.336,0,0,1,.336-.336Z",
    transform: "translate(-281.562 -116.308)",
    fill: "#fda57d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1220",
    "data-name": "Tracciato 1220",
    d: "M526.022,197.2a5.375,5.375,0,0,0,3.735.01v-.459h-3.735Z",
    transform: "translate(-515.654 -178.933)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellisse_105",
    "data-name": "Ellisse 105",
    cx: 5.353,
    cy: 5.353,
    r: 5.353,
    transform: "translate(6.89 7.811)",
    fill: "#fda57d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1221",
    "data-name": "Tracciato 1221",
    d: "M499.721,138.723a9.614,9.614,0,0,0,5.859-3.636s3.333,3.67,5.657,3.266a2.025,2.025,0,0,0,0-2.828c-1.347-1.414-2.391-3.2-4.175-2.963s-3.973.337-4.916,1.178S499.721,138.723,499.721,138.723Z",
    transform: "translate(-493.649 -125.209)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1222",
    "data-name": "Tracciato 1222",
    d: "M499.721,138.311a9.614,9.614,0,0,0,5.859-3.636s3.333,3.67,5.657,3.266a2.025,2.025,0,0,0,0-2.828c-1.347-1.414-2.391-3.2-4.175-2.963s-3.973.337-4.916,1.179S499.721,138.311,499.721,138.311Z",
    transform: "translate(-493.649 -124.865)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellisse_106",
    "data-name": "Ellisse 106",
    cx: 0.498,
    cy: 0.934,
    rx: 0.498,
    ry: 0.934,
    transform: "translate(6.389 12.226)",
    fill: "#fda57d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellisse_107",
    "data-name": "Ellisse 107",
    cx: 0.498,
    cy: 0.934,
    rx: 0.498,
    ry: 0.934,
    transform: "translate(17.096 12.226)",
    fill: "#fda57d"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3226",
    "data-name": "Raggruppa 3226",
    transform: "translate(-23014.762 18796.826)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3224",
    "data-name": "Raggruppa 3224",
    transform: "translate(5.581 5.167)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellisse_115",
    "data-name": "Ellisse 115",
    cx: 12.102,
    cy: 12.102,
    r: 12.102,
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1231",
    "data-name": "Tracciato 1231",
    d: "M658.311,292.723s-1.372,6.76-2.121,6.385c0,0,7.223,6.238,13.6,0,0,0-1.123-4.763-2.745-6.385Z",
    transform: "translate(-650.932 -280.513)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1232",
    "data-name": "Tracciato 1232",
    d: "M662.7,342.888a12.046,12.046,0,0,0,6.652-1.991c-.446-2.437-2.143-2.576-2.143-2.576h-9.358s-1.6.132-2.1,2.373a12.046,12.046,0,0,0,6.95,2.193Z",
    transform: "translate(-650.566 -318.647)",
    fill: "#db5f00"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellisse_116",
    "data-name": "Ellisse 116",
    cx: 5.365,
    cy: 5.365,
    r: 5.365,
    transform: "translate(6.643 6.472)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1233",
    "data-name": "Tracciato 1233",
    d: "M451.859,263.171H455.6v3.1a1.767,1.767,0,0,1-1.767,1.767h-.209a1.767,1.767,0,0,1-1.767-1.767Z",
    transform: "translate(-441.736 -246.469)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1234",
    "data-name": "Tracciato 1234",
    d: "M452.2,262.323h3.069a.337.337,0,0,1,.337.337v2.762a1.767,1.767,0,0,1-1.767,1.767h-.209a1.767,1.767,0,0,1-1.767-1.767v-2.762a.337.337,0,0,1,.337-.337Z",
    transform: "translate(-441.737 -245.761)",
    fill: "#be7c5e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1235",
    "data-name": "Tracciato 1235",
    d: "M685.958,326.5a5.387,5.387,0,0,0,3.743.01v-.46h-3.743Z",
    transform: "translate(-675.829 -308.384)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellisse_117",
    "data-name": "Ellisse 117",
    cx: 5.365,
    cy: 5.365,
    r: 5.365,
    transform: "translate(6.643 7.635)",
    fill: "#be7c5e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1236",
    "data-name": "Tracciato 1236",
    d: "M666.1,265.279h10.231s-.873-4.131-4.741-3.868A6.937,6.937,0,0,0,666.1,265.279Z",
    transform: "translate(-659.219 -254.317)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellisse_118",
    "data-name": "Ellisse 118",
    cx: 0.499,
    cy: 0.936,
    rx: 0.499,
    ry: 0.936,
    transform: "translate(6.254 11.835)",
    fill: "#be7c5e"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellisse_119",
    "data-name": "Ellisse 119",
    cx: 0.499,
    cy: 0.936,
    rx: 0.499,
    ry: 0.936,
    transform: "translate(16.735 11.835)",
    fill: "#be7c5e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3225",
    "data-name": "Raggruppa 3225"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1238",
    "data-name": "Tracciato 1238",
    d: "M626.214,209.422a11.268,11.268,0,1,1-11.268,11.268,11.268,11.268,0,0,1,11.268-11.268m0-2.783a14.051,14.051,0,1,0,14.051,14.051A14.051,14.051,0,0,0,626.214,206.639Z",
    transform: "translate(-608.533 -203.352)",
    fill: "#03518c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_627",
    "data-name": "Rettangolo 627",
    width: 3.294,
    height: 3.467,
    transform: "translate(15.601)",
    fill: "#03518c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_628",
    "data-name": "Rettangolo 628",
    width: 3.467,
    height: 3.294,
    transform: "matrix(0.515, -0.857, 0.857, 0.515, 22.984, 4.378)",
    fill: "#03518c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_629",
    "data-name": "Rettangolo 629",
    width: 3.467,
    height: 3.294,
    transform: "matrix(0.875, -0.485, 0.485, 0.875, 28.753, 8.764)",
    fill: "#03518c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_630",
    "data-name": "Rettangolo 630",
    width: 3.294,
    height: 3.467,
    transform: "matrix(0.53, -0.848, 0.848, 0.53, 28.802, 25.658)",
    fill: "#03518c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_631",
    "data-name": "Rettangolo 631",
    width: 3.294,
    height: 3.467,
    transform: "matrix(0.485, -0.875, 0.875, 0.485, 1.981, 9.964)",
    fill: "#03518c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_632",
    "data-name": "Rettangolo 632",
    width: 3.467,
    height: 3.294,
    transform: "matrix(0.848, -0.53, 0.53, 0.848, 1.878, 24.703)",
    fill: "#03518c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_633",
    "data-name": "Rettangolo 633",
    width: 3.294,
    height: 3.467,
    transform: "matrix(0.857, -0.515, 0.515, 0.857, 7.772, 3.103)",
    fill: "#03518c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_634",
    "data-name": "Rettangolo 634",
    width: 3.294,
    height: 3.467,
    transform: "translate(15.601 31.207)",
    fill: "#03518c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_635",
    "data-name": "Rettangolo 635",
    width: 3.294,
    height: 3.467,
    transform: "matrix(0.857, -0.515, 0.515, 0.857, 22.984, 30.296)",
    fill: "#03518c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_636",
    "data-name": "Rettangolo 636",
    width: 3.467,
    height: 3.294,
    transform: "matrix(0.515, -0.857, 0.857, 0.515, 7.772, 31.572)",
    fill: "#03518c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_637",
    "data-name": "Rettangolo 637",
    width: 3.987,
    height: 2.947,
    transform: "translate(0 15.951)",
    fill: "#03518c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_638",
    "data-name": "Rettangolo 638",
    width: 3.987,
    height: 2.947,
    transform: "translate(35.365 18.897) rotate(180)",
    fill: "#03518c"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3230",
    "data-name": "Raggruppa 3230",
    transform: "translate(-22988.969 18776.576)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3229",
    "data-name": "Raggruppa 3229",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3227",
    "data-name": "Raggruppa 3227"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1239",
    "data-name": "Tracciato 1239",
    d: "M786.133,85.512A11.268,11.268,0,1,1,774.864,96.78a11.268,11.268,0,0,1,11.268-11.268m0-2.783A14.051,14.051,0,1,0,800.184,96.78,14.051,14.051,0,0,0,786.133,82.729Z",
    transform: "translate(-768.451 -79.445)",
    fill: "#03518c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_639",
    "data-name": "Rettangolo 639",
    width: 3.294,
    height: 3.467,
    transform: "translate(15.601)",
    fill: "#03518c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_640",
    "data-name": "Rettangolo 640",
    width: 3.467,
    height: 3.294,
    transform: "matrix(0.515, -0.857, 0.857, 0.515, 22.984, 4.378)",
    fill: "#03518c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_641",
    "data-name": "Rettangolo 641",
    width: 3.467,
    height: 3.294,
    transform: "matrix(0.875, -0.485, 0.485, 0.875, 28.753, 8.764)",
    fill: "#03518c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_642",
    "data-name": "Rettangolo 642",
    width: 3.294,
    height: 3.467,
    transform: "matrix(0.53, -0.848, 0.848, 0.53, 28.802, 25.658)",
    fill: "#03518c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_643",
    "data-name": "Rettangolo 643",
    width: 3.294,
    height: 3.467,
    transform: "matrix(0.485, -0.875, 0.875, 0.485, 1.981, 9.964)",
    fill: "#03518c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_644",
    "data-name": "Rettangolo 644",
    width: 3.467,
    height: 3.294,
    transform: "matrix(0.848, -0.53, 0.53, 0.848, 1.878, 24.701)",
    fill: "#03518c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_645",
    "data-name": "Rettangolo 645",
    width: 3.294,
    height: 3.467,
    transform: "matrix(0.857, -0.515, 0.515, 0.857, 7.772, 3.103)",
    fill: "#03518c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_646",
    "data-name": "Rettangolo 646",
    width: 3.294,
    height: 3.467,
    transform: "translate(15.601 31.204)",
    fill: "#03518c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_647",
    "data-name": "Rettangolo 647",
    width: 3.294,
    height: 3.467,
    transform: "matrix(0.857, -0.515, 0.515, 0.857, 22.984, 30.296)",
    fill: "#03518c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_648",
    "data-name": "Rettangolo 648",
    width: 3.467,
    height: 3.294,
    transform: "matrix(0.515, -0.857, 0.857, 0.515, 7.772, 31.572)",
    fill: "#03518c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_649",
    "data-name": "Rettangolo 649",
    width: 3.987,
    height: 2.947,
    transform: "translate(0 15.949)",
    fill: "#03518c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_650",
    "data-name": "Rettangolo 650",
    width: 3.987,
    height: 2.947,
    transform: "translate(35.365 18.897) rotate(180)",
    fill: "#03518c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3219",
    "data-name": "Raggruppa 3219",
    transform: "translate(5.319 4.973)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellisse_108",
    "data-name": "Ellisse 108",
    cx: 12.363,
    cy: 12.363,
    r: 12.363,
    transform: "translate(0 0)",
    fill: "#b8b8b8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3228",
    "data-name": "Raggruppa 3228",
    transform: "translate(5.602 5.155)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellisse_109",
    "data-name": "Ellisse 109",
    cx: 12.102,
    cy: 12.102,
    r: 12.102,
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1223",
    "data-name": "Tracciato 1223",
    d: "M822.62,218.979a12.046,12.046,0,0,0,6.652-1.991c-.446-2.437-2.143-2.576-2.143-2.576h-9.357s-1.6.132-2.1,2.373A12.047,12.047,0,0,0,822.62,218.979Z",
    transform: "translate(-810.506 -194.727)",
    fill: "#db5f00"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellisse_110",
    "data-name": "Ellisse 110",
    cx: 5.842,
    cy: 5.842,
    r: 5.842,
    transform: "translate(6.144 6.007)",
    fill: "#72351c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1224",
    "data-name": "Tracciato 1224",
    d: "M611.777,139.261h3.743v3.1a1.767,1.767,0,0,1-1.767,1.767h-.209a1.767,1.767,0,0,1-1.767-1.767Z",
    transform: "translate(-601.676 -122.547)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1225",
    "data-name": "Tracciato 1225",
    d: "M612.114,138.414h3.069a.337.337,0,0,1,.337.337v2.762a1.767,1.767,0,0,1-1.767,1.767h-.209a1.767,1.767,0,0,1-1.767-1.767v-2.762a.337.337,0,0,1,.337-.337Z",
    transform: "translate(-601.676 -121.839)",
    fill: "#fda57d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1226",
    "data-name": "Tracciato 1226",
    d: "M845.875,202.589a5.387,5.387,0,0,0,3.743.01v-.46h-3.743Z",
    transform: "translate(-835.767 -184.461)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellisse_111",
    "data-name": "Ellisse 111",
    cx: 5.365,
    cy: 5.365,
    r: 5.365,
    transform: "translate(6.621 7.647)",
    fill: "#fda57d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1227",
    "data-name": "Tracciato 1227",
    d: "M834.005,136.933s2.261,4.59,8.639,1.924l-1.485-2.329-2.632-.945Z",
    transform: "translate(-825.84 -128.801)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1228",
    "data-name": "Tracciato 1228",
    d: "M834.005,136.521s2.261,4.59,8.639,1.924l-1.485-2.329-2.632-.945Z",
    transform: "translate(-825.84 -128.455)",
    fill: "#72351c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1229",
    "data-name": "Tracciato 1229",
    d: "M833.311,122.607a3.1,3.1,0,0,1,.768-1.249c1.055-1.043,2.785-1.263,3.673-2.453a.694.694,0,0,1-.318.98,2.708,2.708,0,0,0,2.316-.78,1.59,1.59,0,0,1-.268,1.679,1.606,1.606,0,0,1,1.606,1.3,1.5,1.5,0,0,1-.694,1.264,3.859,3.859,0,0,1-1.4.528C837.559,124.189,832.376,125.513,833.311,122.607Z",
    transform: "translate(-825.165 -114.852)",
    fill: "#72351c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1230",
    "data-name": "Tracciato 1230",
    d: "M835.318,173.928h-.142l-2.767,2.464a4.974,4.974,0,0,0-4.623,0l-2.9-2.362-.293.037a5.365,5.365,0,1,0,10.728-.138Zm-5.373,3.408c-1.044,0-1.89-.212-1.89-.472s.846-.472,1.89-.472,1.89.211,1.89.472-.846.473-1.89.473Z",
    transform: "translate(-817.966 -160.869)",
    fill: "#72351c"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellisse_112",
    "data-name": "Ellisse 112",
    cx: 0.499,
    cy: 0.936,
    rx: 0.499,
    ry: 0.936,
    transform: "translate(6.119 12.072)",
    fill: "#fda57d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellisse_113",
    "data-name": "Ellisse 113",
    cx: 0.499,
    cy: 0.936,
    rx: 0.499,
    ry: 0.936,
    transform: "translate(16.852 12.072)",
    fill: "#fda57d"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamWorking);
export default __webpack_public_path__ + "static/media/team_working.6d2f990a3740b2056f2aef66aef64975.svg";
export { ForwardRef as ReactComponent };